module.exports = __webpack_public_path__ + "img/1468555766.8fd52c0e.jpg";